interface GeneratePathProps {
  basePath: string;
  params: Record<string, string | number>;
}

export const generatePath = ({ basePath, params }: GeneratePathProps) => {
  const stringParams = Object.entries(params).reduce<Record<string, string>>(
    (result, current) => {
      const [key, value] = current;
      result[key] = `${value}`;
      return result;
    },
    {}
  );
  const searchParams = new URLSearchParams(stringParams);

  return `${basePath}?${searchParams.toString()}`;
};
